/**
 * The final-round ask's length cap, mirrored from the proxy's
 * `lib/finalRoundMessages.js`.
 *
 * A `maxLength` on the textarea is a courtesy, not the guard: the proxy slices
 * to the same number whatever arrives. Duplicated as a constant rather than
 * fetched, the same trade `nudgeLimits.ts` takes — but if one moves, move both.
 *
 * Higher than the nudge's 2000 because this message LISTS options, up to six
 * blocks of several lines each.
 */
export const MAX_ASK_CHARS = 4000;
